import styled from 'styled-components';

const Background = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #ffffffdb;
    backdrop-filter: blur(4px);
    display: block;
    z-index: 999999;
    transition: opacity 0.3s ease;
    backdrop-filter: blur(4px);
`;

export { Background };
